import classNames from "classnames";
import { createPortal } from "react-dom";
import { IconClose } from "@salutejs/plasma-icons";

import { isObject } from "@monorepo/utils";
import { useResize } from "@monorepo/hooks";
import { TABLET_BREAKPOINT } from "@monorepo/const";

import { useModalContext } from "../context";
import styles from "./Root.module.scss";

import type { MouseEvent } from "react";

export const Root = () => {
    const { modals, close, container } = useModalContext();
    const width = useResize();
    const isMobile = width < TABLET_BREAKPOINT;

    if (!container) {
        return null;
    }

    const nodes = modals.map((modal) => {
        const handleBackdropClick = (event: MouseEvent<HTMLDivElement>) => {
            if (modal.options.closeOnBackdrop && event.target === event.currentTarget) {
                close(modal.id);
            }
        };

        const handleModalClick = (event: MouseEvent<HTMLDivElement>) => {
            event.stopPropagation();
        };

        const actualPadding = isObject(modal.options.padding) ? modal.options.padding : { padding: modal.options.padding };

        return (
            <div
                key={modal.id}
                className={classNames(styles.backdrop, modal.options.backdropClassName)}
                onMouseDown={handleBackdropClick}
            >
                <div
                    className={classNames(styles.modal, modal.options.className)}
                    style={{
                        ...actualPadding,
                        borderRadius: isMobile ? 0 : modal.options.borderRadius,
                    }}
                    onMouseDown={handleModalClick}
                >
                    {modal.options.showCloseButton && (
                        <button
                            style={{
                                top: 20,
                                right: 20,
                            }}
                            className={styles.closeButton}
                            type="button"
                            onClick={() => close(modal.id)}
                        >
                            <IconClose size="m" color="#000000" />
                        </button>
                    )}
                    {modal.render({
                        close: () => close(modal.id),
                    })}
                </div>
            </div>
        );
    });

    return createPortal(nodes, container);
};
